<h1 mat-dialog-title class="popup-title w-100">
  {{data.Title}}
</h1>
<div mat-dialog-content class="popup-content">
  {{data.Content}}</div>
<div mat-dialog-actions class=" popup-buttons d-flex justify-content-end">
  <button [mat-dialog-close]="true" class=" popup-okbutton btn">Ok</button>
  <button mat-dialog-close class=" popup-cancelbutton btn ml-2">Cancel</button>
</div>